﻿import { hasValueForQueryParameter } from "./hasValueForQueryParameter";

const QUERY_STRING_CHARACTER = "?";
const QUERY_PARAMETER_SEPARATOR = "&";

export const buildParameterizedUrl = (url, value) => {
  if (!url || !hasValueForQueryParameter(value)) return;

  const queryString = `${
    url.includes(QUERY_STRING_CHARACTER)
      ? QUERY_PARAMETER_SEPARATOR
      : QUERY_STRING_CHARACTER
  }query=${encodeURIComponent(value)}&ignoreFilter=true`;

  return url + queryString;
};
